<template>
  <div class="">
    <van-nav-bar
      title="收货地址选择"
      left-text="返回"
      left-arrow
      @click-left="onClickLeft"
    />
    <!-- default-tag-text="默认" -->
    <!--  -->
    <van-address-list
      v-model="chosenAddressId"
      :list="list"
      :disabled-list="disabledList "
      @add="onAdd"
      @edit="onEdit"
      @select="onChange"
    />
    <div
      class="meng"
      v-show="show"
    >
      <van-loading
        size="24px"
        color="#1989fa"
      >加载中...</van-loading>
    </div>

  </div>
</template>
<script>
import Vue from 'vue'
import { NavBar, AddressList, Toast, Loading } from 'vant'

Vue.use(NavBar).use(AddressList).use(Toast).use(Loading)
export default {
  created () {
    this.getlist()
  },
  data () {
    return {
      chosenAddressId: '1',
      list: [
        // {
        //   id: '1',
        //   name: '张三',
        //   tel: '13000000000',
        //   province: "浙江省",//省
        //   city: "杭州市",//市
        //   county: "西湖区",//区
        //   addressDetail: "文三路 138 号东方通信大厦 7 楼 501 室",//详细地址
        //   areaCode: "110101",
        //   address: '浙江省杭州市西湖区文三路 138 号东方通信大厦 7 楼 501 室',
        //   isDefault: true
        // },
        // {
        //   id: '2',
        //   name: '李四',
        //   tel: '1310000000',
        //   address: '浙江省杭州市拱墅区莫干山路 50 号',
        // },
      ],
      disabledList: [
        // {
        //   id: '3',
        //   name: '王五',
        //   tel: '1320000000',
        //   address: '浙江省杭州市滨江区江南大道 15 号',
        // },
      ],
      show: true
    };
  },
  methods: {
    getlist () {

      this.axios.get('listAddress').then(res => {
        // console.log(res)
        if (res.data.code == 1004) {
          localStorage.setItem('token', JSON.stringify({ id: res.data.token }))
          this.getlist()
        }
        if (res.data.code == 200) {
          this.show = false
          res.data.data.forEach(v => {
            // console.log(v)
            let obj = {}
            obj.name = v.realname
            obj.tel = v.mobile
            obj.id = v.id
            obj.province = v.prov
            obj.city = v.city
            obj.county = v.dist
            obj.addressDetail = v.address_detail
            obj.address = v.prov + v.city + v.dist + v.address_detail
            obj.isDefault = v.is_default ? true : false
            // console.log(obj)
            this.list.push(obj)
          });
        }
      }).catch(ref => {
        console.log(ref)
      })
    },
    onClickLeft () {
      this.$router.go(-1)
    },
    onAdd () {
      if (this.$route.params.id == 1) {
        this.$router.push({ name: 'reviseads', params: { id: 1, txt: '新增地址' } })
      } else {
        this.$router.push({ name: 'reviseads', params: { txt: '新增地址' } })
      }

    },
    onEdit (item, index) {
      Toast('下单时请勿修改，请新加地址！')
    },
    onChange (i) {
      console.log(this.$route.query.name)
      if (this.$route.query.name == 'order') {
        this.$router.push({ name: 'order', params: { address: i } })
      } else {
        this.$router.push({ name: 'chuxo', params: { address: i } })
      }
      // this.$stoer
      // this.$router.push({ name: 'order', params: { address: i } })

    }
  }
}
</script>
<style lang="less" scoped>
.meng {
  position: fixed;
  top: 1.5rem;
  left: 0;
  padding: 40%;
  width: 100%;
  z-index: 999;
  height: 100%;
  text-align: center;
  background-color: rgba(0, 0, 0, 0.3);
}
</style>
